import { render, staticRenderFns } from "./AddEditTemplate.vue?vue&type=template&id=11641673&scoped=true"
import script from "./AddEditTemplate.vue?vue&type=script&lang=js"
export * from "./AddEditTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddEditTemplate.vue?vue&type=style&index=0&id=11641673&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11641673",
  null
  
)

export default component.exports